import { LeaveRegistrationButton } from "Components/Onboarding/shared/LeaveRegistrationButton";
import { useNavigate } from "Navigation/useNavigate";
import { resetUser } from "State/Auth/AuthReducer";
import { appUrl } from "Utils/UrlUtils";
import { useDispatch } from "react-redux";

export const LogoutButton = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const logout = () =>
    dispatch(
      resetUser({
        onAfterReset: () => navigate(appUrl("sign-in"), { replace: true }),
      }),
    );

  return <LeaveRegistrationButton onClick={logout} />;
};
